import { FLAG } from '@shared/products-types';

export const isPermitted = (flags: string[], permissionFlags: string[]): boolean =>
    flags.includes(FLAG.viewBalanceAllowed) || permissionFlags.includes('VIEW_BALANCE_ALLOWED');
